import React from "react";
import Lottie from "react-lottie";

const LottieAnimation = (
  {
    animationData,
    loop = false,
    autoplay = true,
    width = '',
    height = '',
    isVisible = false,
    classname = "",
    handleComplete = () => { }
  },
) => {
  const defaultOptions = {
    loop: loop,
    autoplay: isVisible ? autoplay : false,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
      className: classname,
    },
  };

  const eventListeners = [
    {
      eventName: "complete",
      callback: () => {
        handleComplete();
      },
    },
  ];

  return <Lottie eventListeners={eventListeners} options={defaultOptions} height={height} width={width} isStopped={!isVisible} />;
};

export default LottieAnimation;



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/ui/lottie-animation/LottiAnimation.jsx